module.exports = __webpack_public_path__ + "img/equipo_16-9_2880.6ca7fd53.webp";